customOmitClone